import { Stack, Typography } from "@mui/material";

import type { FC } from "react";

export const AnalyticsOverviewClicks: FC<{
  data: {
    count: number;
  };
}> = ({ data }) => (
  <Stack direction="row" alignItems="baseline" spacing={1}>
    <Typography variant="h5">
      {data.count} {data.count === 1 ? "Click" : "Clicks"}
    </Typography>
  </Stack>
);
